<template>
  <div class="sidebar">
    <h2 class="elements-label">Page <i>{{ currentPage ? currentPage.Name : "..." }}</i><br/>Blocs / Propriétés</h2>
    <div v-if="currentPage" v-for="(e, index) in currentPage.getPropertiesDescription()" :key="e.name" class="array-item">
      <component :is="e.jsType" :element="currentPage[e.name]" :container="currentPage" :property="e"/>
    </div>
    <div v-if="currentPage" v-for="(e, index) in currentPage.getCompositionsDescription()" :key="e.name" class="array-item">
      <component :labeled="false" :is="e.jsType" :element="currentPage[e.name]" :container="currentPage" :property="e"/>
    </div>

    <!-- Bouton d'ajout d'élément -->
    <button class="add-element-button" @click="showAddElementPopup = true">
      <addIcon/>
      Ajouter un bloc
    </button>
    <!-- Bouton photo d'identité -->
    <button class="add-element-button" @click="showSelectionCompositionPopup = true">
      <compositionIcon/>
      Gérer les compositions
    </button>

    <!-- Popup d'ajout d'élément -->
    <AddElementPopup title="Ajouter un élément" :elements="getPageElementPossible" :show="showAddElementPopup" @select="addElement" @close="showAddElementPopup = false" />
    <!-- Popup selection composition -->
    <CompositionSelectionPopup :show="showSelectionCompositionPopup" @close="showSelectionCompositionPopup = false" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as namespaceStore from "../../vuexStore/namespaceStore.js"
import * as actions from "../../vuexStore/actions.js"
import screenSize from "../../vuexStore/type/definition/screenSize.js"
import ArraySidebar from "./SidebarComponents/array.vue"
import ClassSidebar from "./SidebarComponents/class.vue"
import NumberSidebar from "./SidebarComponents/number.vue"
import backgroundIcon from "../IconComponents/backgroundIcon.vue"
import backIcon from "../IconComponents/backIcon.vue"
import cancelIcon from "../IconComponents/cancelIcon.vue"
import nextIcon from "../IconComponents/nextIcon.vue"
import validateIcon from "../IconComponents/validateIcon.vue"
import imageCarouselIcon from "../IconComponents/imageCarouselIcon.vue"
import addIcon from "../IconComponents/addIcon.vue"
import compositionIcon from "../IconComponents/compositionIcon.vue"
import AddElementPopup from "../PopupComponents/AddElementPopup.vue"
import CompositionSelectionPopup from "../PopupComponents/CompositionSelectionPopup.vue"

export default {
  name: 'Sidebar',
  props: {
  },
  emits: [
  ],
  components: {
    Array: ArraySidebar,
    Class: ClassSidebar,
    Number: NumberSidebar,
    backgroundIcon,
    backIcon,
    cancelIcon,
    nextIcon,
    validateIcon,
    imageCarouselIcon,
    addIcon,
    compositionIcon,
    AddElementPopup,
    CompositionSelectionPopup
  },
  data() {
    return {
      showAddElementPopup: false,
      showSelectionCompositionPopup: false,
      IndexExpanded: null,
    }
  },
  computed: {
    ...mapGetters(namespaceStore.THEME, [
      'getPageElementPossible',
      'currentPage',
      'compositions'
    ]),
  },
  methods: {
    ...mapActions(namespaceStore.THEME, {
      'addElementAction': actions.ADD_ELEMENT
    }),
    checkElementAlreadyExist(name, id) {
      if (this.currentPage[name]) {
        if (Array.isArray(this.currentPage[name])) {
          return this.currentPage[name].some(e => e.id == id);
        }
        else {
          return this.currentPage[name].id == id;
        }
      }
      return false;
    },
    addElement(element) {
      const position = {
        x: (screenSize.width / 2) - (screenSize.width * 0.5 / 2),
        y: (screenSize.height / 2) - (screenSize.height * 0.25 / 2),
        largeur: screenSize.width * 0.5,
        hauteur: screenSize.height * 0.25,
      };
      let propertyForCreation = {
        name: element.text,
        position: position,
        property: element.property
      };
      if (element.multipleConstructorParameter) {
        let toAdd = [];
        element.multipleConstructorParameter.forEach((e) => {
          if (e.id) {
            if (this.checkElementAlreadyExist(element.name, e.id) == false)
              toAdd.push(element.constructor.fromObject({...propertyForCreation, ...e}));
          }
          else {
            toAdd.push(element.constructor.fromObject({...propertyForCreation, ...e}));
          }
        });
        if (toAdd.length > 0) {
          this.addElementAction({
            target: element.name,
            toAdd: toAdd,
            element: null
          });
        }
      }
      else {
        if (element.constructorParameter) {
          propertyForCreation = {...propertyForCreation, ...element.constructorParameter};
        }
        this.addElementAction({
          target: element.name,
          toAdd: element.constructor.fromObject(propertyForCreation),
          element: null
        });
      }
      this.showAddElementPopup = false;
    },
    setExpend: function(index) {
      if (this.IndexExpanded === index)
        this.IndexExpanded = undefined;
      else
        this.IndexExpanded = index;
    }
  }
}
</script>

<style scoped>
.sidebar {
  padding: 1rem;
}

.elements-label {
  color: #fff;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
}

.add-element-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem;
  background-color: rgba(59, 130, 246, 0.2);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 0.375rem;
  color: #fff;
  font-weight: 500;
  transition: all 0.2s ease;
  margin-bottom: 1rem;
}

.add-element-button:hover {
  background-color: rgba(59, 130, 246, 0.3);
  border-color: #3b82f6;
}

.add-element-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.4);
}

.close-button {
  font-family: Avenir;
}
</style> 